import styled from 'styled-components';
import { Table } from 'antd';
import { consoleTable, panel, panelHeader, panelTitle, segButton } from 'components/explore/consoleStyled';

export const SegmentsContainer = styled.div`
  ${panel}
`;

export const HeaderRow = styled.div`
  ${panelHeader}
`;

export const SegmentsLabel = styled.div`
  ${panelTitle}
`;

export const ExpandIcon = styled.span`
  margin-right: 6px;
  font-size: 10px;
`;

export const TabButton = styled.button<{ active: boolean }>`
  ${segButton}
`;

export const StyledTable = styled(Table)`
  ${consoleTable}
`;

export const ClickableUUID = styled.span`
  color: var(--accent);
  cursor: pointer;
  font-family: var(--f-mono);
  font-size: 12px;

  &:hover {
    text-decoration: underline;
  }
`;
